export enum DataRoomStatus {
  Live = 'live',
  Inactive = 'inactive'
}

export const dataRoomStatusValues = Object.values(DataRoomStatus).map(value => value)
